import { SIZE_50 } from '@/lib/gridElements/size';

import { BubbleMapChart } from '@/components/composite/Charts/BubbleMapChart';

export const citiesDistributionConfig = {
    title: 'chart.instagram.cities_distribution',
    height: 300,
    name: {
        city: 'chart.instagram.cities_distribution_city',
        value: 'chart.instagram.cities_distribution_value',
        lat: 'chart.instagram.cities_distribution_lat',
        lng: 'chart.instagram.cities_distribution_lng',
        percentage: 'percentage'
    },
    defaultTableSorting: [{ id: 'value', desc: true }],
    tooltip: 'chart.instagram.cities_distribution_tooltip',
    noLegend: true,
    datePickerDoesNotApply: true,
    id: 'cities_distribution',
    size: SIZE_50,
    type: 'chart',
    element: BubbleMapChart
};
